export var ChartSettingsElementType;
(function (ChartSettingsElementType) {
    ChartSettingsElementType["TEXT_INPUT"] = "InputText";
    ChartSettingsElementType["NUMBER_INPUT"] = "InputNumber";
    ChartSettingsElementType["DATE_INPUT"] = "InputText";
    ChartSettingsElementType["RADIO"] = "Radio";
    ChartSettingsElementType["RADIO_GROUP"] = "RadioGroup";
    ChartSettingsElementType["CHECKBOX"] = "Checkbox";
    ChartSettingsElementType["CHECKBOX_GROUP"] = "CheckboxGroup";
    ChartSettingsElementType["CHECKBOX_GROUP_ITEM"] = "CheckboxGroupItem";
    ChartSettingsElementType["NUMBER_RANGE"] = "NumberRange";
    ChartSettingsElementType["DROPDOWN"] = "Dropdown";
    ChartSettingsElementType["COLOR_PICKER"] = "ColorPicker";
    ChartSettingsElementType["TOGGLE"] = "Toggle";
    ChartSettingsElementType["BUTTON"] = "Button";
    ChartSettingsElementType["TYPOGRAPHY"] = "Typography";
    ChartSettingsElementType["TAB"] = "Tab";
    ChartSettingsElementType["TAB_ITEM"] = "TabItem";
    ChartSettingsElementType["ACCORDION"] = "Accordion";
    ChartSettingsElementType["ACCORDION_ITEM"] = "AccordionItem";
    ChartSettingsElementType["FONT_FORMATTER"] = "Formatter";
    ChartSettingsElementType["NUMBER_FORMATTER"] = "NumberFormatter";
    ChartSettingsElementType["LINE_FORMATTER"] = "LineFormatter";
    ChartSettingsElementType["INTERVAL_FORMATTER"] = "IntervalFormatter";
    ChartSettingsElementType["BACKGROUND_FORMATTER"] = "BackgroundFormatter";
    ChartSettingsElementType["MARKER_FORMATTER"] = "MarkerFormatter";
    ChartSettingsElementType["VIEW"] = "View";
    ChartSettingsElementType["TOOLTIP_CONFIGURATOR"] = "TooltipConfigurator";
    ChartSettingsElementType["CONDITIONAL_FORMATTER"] = "ConditionalFormatter";
    ChartSettingsElementType["POSITION_CONTROL"] = "PositionControl";
    ChartSettingsElementType["INHERITANCE_WIDGET"] = "InheritanceWidget";
    ChartSettingsElementType["SECTION"] = "Section";
    ChartSettingsElementType["LABELLED_VIEW"] = "LabelledView";
    ChartSettingsElementType["MULTILEVEL_DROPDOWN"] = "MultilevelDropdown";
    ChartSettingsElementType["CHART_ZOOM"] = "ChartZoom";
    ChartSettingsElementType["BACKGROUND_IMAGE_EDITOR"] = "BackgroundImageEditor";
    ChartSettingsElementType["CHART_DATA_COLOR_PICKER"] = "ChartDataColorPicker";
    ChartSettingsElementType["NUMERIC_FILTER_INPUT"] = "NumericFilterInput";
    ChartSettingsElementType["COLUMN_RENAME_INPUT"] = "ColumnRenameInput";
    ChartSettingsElementType["SORT_FORMAT"] = "SortFormat";
    ChartSettingsElementType["TEXT_WRAP_TOGGLE"] = "TextWrapToggle";
    ChartSettingsElementType["MAX_DATA_POINTS_INPUT"] = "MaxDataPointsInput";
    ChartSettingsElementType["AXIS_RENAME_INPUT"] = "AxisRenameInput";
    ChartSettingsElementType["TABLE_COLUMN_RENAME_INPUT"] = "TableColumnRenameInput";
    ChartSettingsElementType["GRADIENT_PICKER_V2"] = "GradientPickerV2";
})(ChartSettingsElementType || (ChartSettingsElementType = {}));
export var ChartSettingsV2MenuItems;
(function (ChartSettingsV2MenuItems) {
    ChartSettingsV2MenuItems["CHART_TYPE"] = "CHART_TYPE";
    ChartSettingsV2MenuItems["LAYOUT"] = "LAYOUT";
    ChartSettingsV2MenuItems["COLUMN"] = "COLUMN";
    ChartSettingsV2MenuItems["AXIS"] = "AXIS";
    ChartSettingsV2MenuItems["DATA_LABEL"] = "DATA_LABEL";
    ChartSettingsV2MenuItems["TOOLTIP"] = "TOOLTIP";
    ChartSettingsV2MenuItems["LEGEND"] = "LEGEND";
    ChartSettingsV2MenuItems["DISPLAY"] = "DISPLAY";
    ChartSettingsV2MenuItems["QUERY_DETAILS"] = "QUERY_DETAILS";
    ChartSettingsV2MenuItems["R_ANALYSIS"] = "R_ANALYSIS";
    ChartSettingsV2MenuItems["CUSTOM_ACTION"] = "CUSTOM_ACTION";
    ChartSettingsV2MenuItems["MUZE_AI"] = "MUZE_AI";
})(ChartSettingsV2MenuItems || (ChartSettingsV2MenuItems = {}));
export var CustomAPIHandler;
(function (CustomAPIHandler) {
    CustomAPIHandler["UpdateColumn"] = "updateColumn";
    CustomAPIHandler["RenameColumn"] = "renameColumn";
    CustomAPIHandler["UpdateAnswerColumnClientState"] = "updateAnswerColumnClientState";
    CustomAPIHandler["DataSizeUpdate"] = "dataSizeUpdate";
    CustomAPIHandler["UpdateHeadlineVisibility"] = "updateHeadlineVisibility";
    CustomAPIHandler["UpdateAllHeadlineVisibility"] = "updateAllHeadlineVisibility";
    CustomAPIHandler["UpdateHeadlineVizClientState"] = "updateHeadlineVizClientState";
})(CustomAPIHandler || (CustomAPIHandler = {}));
//# sourceMappingURL=chart-settings-v2-schema.types.js.map